import React from 'react';
import { CircuitRenderer, CircuitElement } from './CircuitRenderer';

interface RCCircuitDiagramProps {
    voltage: number;
    resistance: number;
    capacitance: number;
    timeConstant?: boolean; // Show time constant label?
}

export const RCCircuitDiagram: React.FC<RCCircuitDiagramProps> = ({
    voltage,
    resistance,
    capacitance,
    timeConstant: _timeConstant
}) => {
    // _timeConstant available for future use (e.g., showing τ=RC label)
    // Series RC Circuit
    // (V) --- [R] --- || --- |
    //  |                     |
    //  ----------------------|

    const width = 450;
    const height = 300;
    const padding = 50;

    const leftX = padding + 40;
    const rightX = width - padding - 40;
    const topY = padding + 20;
    const bottomY = height - padding - 20;

    const elements: CircuitElement[] = [
        // Voltage Source
        {
            type: 'voltageSource',
            from: { x: leftX, y: bottomY },
            to: { x: leftX, y: topY },
            value: voltage,
            labelSide: 'left'
        },

        // Top Resistor
        {
            type: 'resistor',
            from: { x: leftX, y: topY },
            to: { x: rightX, y: topY },
            value: resistance,
            label: `R=${resistance}Ω`,
            labelSide: 'left'
        },

        // Right Capacitor
        {
            type: 'capacitor',
            from: { x: rightX, y: topY },
            to: { x: rightX, y: bottomY },
            value: capacitance,
            label: `C=${capacitance}F`,
            labelSide: 'left' // Outside (Right)
        },

        // Bottom Wire
        {
            type: 'wire',
            from: { x: rightX, y: bottomY },
            to: { x: leftX, y: bottomY },
            labelSide: 'left'
        }
    ];

    return (
        <CircuitRenderer width={width} height={height} elements={elements} />
    );
};
